<template>
  <div class="modal_card edit_ticket">
    <div class="header">
      <h4 class="title">
        {{ translate('support.add') }}
      </h4>
    </div>
    <div class="content">
      <form>
        <div class="row">
          <div class="col-md-12" v-if="false">
            <fg-input
              v-model="ticket_info.device_id"
              type="text"
              :label="translate('support.device')"
              :placeholder="translate('support.device')"
              readonly
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label> {{ translate('support.subject') }} </label>
              <tree-select
                v-model="ticket_info.topic_id"
                :options="topic_list"
                :placeholder="translate('support.subject')"
                :clearable="false"
                :max-height="350"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>{{ translate('support.descr') }}</label>
              <textarea
                v-model="ticket_info.text"
                rows="5"
                class="form-control border-input"
                :placeholder="translate('support.descr')"
              />
            </div>
          </div>
        </div>

        <div class="row" v-if="$store.getters.getPermissions.permissionGod === true">
          <div class="col-md-12">
            <div class="filter checkbox">
              <div class="info">
                {{ translate('support.new_message_telegram') }}
              </div>
              <label class="switch" @click.prevent="ticket_info.send_alert = !ticket_info.send_alert">
                <input type="checkbox" v-model="ticket_info.send_alert">
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button
            class="btn btn-info btn-fill btn-wd"
            @click.prevent="open_ticket"
            :disabled='disabled_btn'
          >
            {{ translate("support.add") }}
          </button>
          <button
            type="submit"
            class="btn btn-danger btn-fill btn-wd"
            @click.prevent="cancel"
          >
            Cancel
          </button>
        </div>
        <div class="clearfix" />
      </form>
    </div>
  </div>
</template>
<script>

import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm.vue";
import store from "@/Store/Store";

export default {
  name: "NewTicket",
  props: ['ticket', 'device_id'],
  data () {
    return {
      ticket_info: {},
      disabled_btn: false,
      confirm: false,
    }
  },
  beforeMount () {
    this.ticket_info = {...this.ticket, send_alert: false}
    if (this.device_id) {
      this.ticket_info.device_id = this.device_id
    }
  },
  computed:{
    store() {
      return store
    },
    topic_list(){
      return this.$store.getters.getTicketTopics.map((topic) => {
        return {id: topic.id, label: topic.name}
      })
    },
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    confirm_open_ticket () {
      let t = this.$createElement(GlobalConfirm, {
        props: {
          text: this.translate('support.confirm_ticket')
        },
        on: {
          close: () => {
            this.disabled_btn = false
            this.$modal.hide('confirm_ticket')
          },
          confirm: () => {
            this.confirm = true
            this.open_ticket()
            this.$modal.hide('confirm_ticket')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'confirm_ticket'})
    },
    open_ticket(){
      this.disabled_btn = true
      this.ticket_info.confirm = this.confirm
      let ticket_info = {...this.ticket_info}
      if (ticket_info.send_alert === false){
        delete ticket_info.send_alert
      }
      this.$http.v1.openTicket(ticket_info, (response) => {
        if (response.data.error){
          this.confirm_open_ticket()
        }else{
          this.global_notify('info', this.translate('support.new_ticket'))
          // this.$store.dispatch('ticketList')
          this.$emit('update')
          this.$emit('close')
        }
      }, (bad_answer) => {
        this.bad_answer_handler(bad_answer)
        this.disabled_btn = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .modal_card{
    width: 100%;
    border-radius: 3px;
    box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
    color: #252422;
    position: relative;
    border: 1px solid #ccc;
    min-height: 85px;
    background-color: #f8f8f8;
    padding: 10px;

    .header{
      .title{
        text-align: center;
        margin: 10px 0;
      }
    }
    .content{
      textarea{
        background-color: #fffcf5;
        border-radius: 4px;
        color: #66615b;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        box-shadow: none;
        border: 1px solid #e8e8e8;
        height: 300px;
      }
    }
    .buttons{
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
    }
  }

</style>
